import React, {useState} from 'react'
import { TextField, Button, FormControlLabel, Checkbox, Snackbar, Typography} from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import userService from '../Services/user'
import { useHistory } from 'react-router-dom'
import firebase from '../Services/firebase'

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />
}


function Join() {
    var history = useHistory()
    const [roomName, setRoomName] = useState("")
    const [userName, setUserName] = useState("")
    const [password, setPassword] = useState("")

    const [validationError, setValidationError] = useState("")
    const [isPasswordProtected, setIsPasswordProtected] = useState(false)

    const [open, setOpen] = React.useState(false)
    const [cLoader, setCLoader]= useState(false)
    const [passwordError, setPasswordError] = useState(false)

    const handleChange = ()=>{
        setIsPasswordProtected(!isPasswordProtected)
    }

    const handleClickError = () => {
        setOpen(true)
    }

    const handleCloseError = (event, reason) => {
        if(reason === 'clickaway'){return}
        setOpen(false)
    }


    const validate = ()=>{
        if(isPasswordProtected){
            if(!password){
                setValidationError("Password can not be empty*")
                handleClickError()
                return false
            }
        }

        if(!roomName){
            setValidationError("Room name can not be empty")
            handleClickError()
            return false
        }

        return true
    }

    const submitJoin = ()=>{

        if(validate()){
            setCLoader(true)  
            const data = {
                roomName: roomName,
                userName : userName,
                password: password
            }

            var starCountRef = firebase.database().ref('rooms/' + data.roomName + "/password")
            var roomRef = firebase.database().ref("/rooms/" + data.roomName + "/people")

            starCountRef.once('value', function(snapshot) {
                var password = snapshot.val() 
                console.log(password)

                if(password !== null){
                    if(password === data.password){
                        var newUser = userService.join(roomName, password, userName)

                        roomRef.child(newUser.userUID).set(newUser)
                        .then((data2)=>{
                            console.log(data2)
                            setCLoader(false)
                            history.push('/room?name='+data.roomName)
                        })
                    }else{
                        setCLoader(false)
                        setPasswordError(true)
                        setValidationError("Your Password is Wrong")
                        handleClickError()
                    }
                } else{
                    setCLoader(false)
                    setValidationError("Room not Exists")
                    handleClickError()
                }
                
            })
        }
    }

    return (
        <div>
           
            <div>
                <div style={{marginTop: '10px', paddingTop:'10px'}}>
                    <div style={{display:'flex', flexDirection: 'column', margin: '5px'}}>
                        <TextField
                            style={{margin:'10px'}}
                            required
                            id="outlined-required"
                            label="Room Name"
                            value={roomName}
                            variant="outlined"
                            onChange={(e)=>{setRoomName(e.target.value)}}
                        />

                        <TextField
                            style={{margin:'10px'}}
                            id="outlined-required"
                            label="Your Name"
                            value={userName}
                            variant="outlined"
                            onChange={(e)=>{setUserName(e.target.value)}}
                        />

                        <div style={{textAlign:'left', margin: '10px'}}>
                            <FormControlLabel
                                value={isPasswordProtected}
                                control={
                                <Checkbox color="primary" checked={isPasswordProtected} onChange={handleChange} />
                            }
                                label="Password Protected"
                                labelPlacement="end"
                            />
                        </div>

                        
                            {isPasswordProtected ? (
                                <TextField
                                    style={{margin:'10px'}}
                                    id="outlined-required"
                                    type="password"
                                    label="Password"
                                    value={password}
                                    variant="outlined"
                                    error={passwordError}
                                    onChange={(e)=>{setPassword(e.target.value)}}
                                />
                            ) : ""}
                        
                        {/* <div style={{textAlign:'left', marginLeft:'11px', marginRight:'12px', marginBottom:'0px'}}>
                            <Typography style={{fontSize: '12px'}}>
                                By Joining, You agreeing to Terms and Conditions
                            </Typography>
                        </div> */}

                        <Button variant="contained" color="primary" style={{margin:'10px'}} onClick={submitJoin}>
                        { cLoader ? "Joining...":   "Join Room"}
                        </Button>

                    </div>     
                </div>

                <div>
                <Snackbar 
                    open={open} 
                    autoHideDuration={3500} 
                    onClose={handleCloseError}
                    anchorOrigin={{vertical:'top', horizontal:'center'}}
                >
                    <Alert onClose={handleCloseError} severity="error">
                        {validationError}
                    </Alert>
                </Snackbar>
                </div>
            </div>
        </div>
    )
}

export default Join
